import { APIS } from "../endpoints";
import api from "../services/api";

export const getMasterListAliasSuggestions = async (limit, page, inputValue) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (inputValue) {
        formData.append('searchTerm', inputValue); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.masterlistAliasSuggestions}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};